import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDraggable } from '@dnd-kit/core';

import IdentitySelectorOption from './IdentitySelectorOption';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
  }),
};

const IdentitySelectorOptionDraggable = ({ identity, className, ...props }) => {
  const { isDragging, setNodeRef, attributes, listeners } = useDraggable({
    id: identity.id,
    data: {
      identity,
    },
  });

  const classes = classNames({
    'manual-matching-identity-selector-option-draggable': true,
    'is-dragging': isDragging,
    [className]: !!className,
  });

  return (
    <div className={classes} ref={setNodeRef} {...attributes} {...listeners}>
      <IdentitySelectorOption identity={identity} {...props} />
    </div>
  );
};

IdentitySelectorOptionDraggable.propTypes = propTypes;

export default IdentitySelectorOptionDraggable;
